Namespace 'Monitoring.Models.SocialContents.LinkedIn.Builders'

class Monitoring.Models.SocialContents.LinkedIn.Builders.LinkedInCommentBuilder

  setParentPostId: (parentPostId) ->
    @parentPostId = parentPostId

  getParentPostId: ->
    @parentPostId

  setParentCommentId: (parentCommentId) ->
    @parentCommentId = parentCommentId

  getParentCommentId: ->
    @parentCommentId


  setText: (text) ->
    @text = text

  getText: ->
    @text

  setCreatedAt: (createdAt) ->
    @createdAt = createdAt

  getCreatedAt: ->
    @createdAt

  setContentId: (contentId) ->
    @contentId = contentId

  getContentId: ->
    @contentId

  setIsBrandContent: (isBrandContent) ->
    @isBrandContent = isBrandContent

  getIsBrandContent: ->
    @isBrandContent

  build: ->
    new Monitoring.Models.SocialContents.LinkedIn.LinkedInComment(@)
